import { forwardRef, memo } from 'react';
import type { StepFormApi } from '@/hooks/useStepValidation';
import type { InterviewActivityStepProps } from '../InterviewActivity.interface';
import { ScorecardStep } from '../../components/ScorecardStep';
import { INTERVIEW_ACTIVITY_COPY } from '../interviewActivity.copy';
import { useScorecardVisibilitySettings } from '@/pages/settings/interview-and-scheduling/score-card/home/api';

export const InterviewActivityScorecard = memo(
  forwardRef<StepFormApi, InterviewActivityStepProps>((props, ref) => {
    const { data: scorecardSettings } = useScorecardVisibilitySettings();
    const showAiToggle = Boolean(
      scorecardSettings?.data?.account_setting?.fill_with_ai_enabled
    );

    return (
      <ScorecardStep
        ref={ref}
        payloadRef={props.payloadRef}
        prefillVersion={props.prefillVersion}
        copy={INTERVIEW_ACTIVITY_COPY.scorecard}
        showAiToggle={showAiToggle}
      />
    );
  })
);

InterviewActivityScorecard.displayName = 'InterviewActivityScorecard';
